import Button from '../Button'
import classnames from 'classnames'
import { getLeftPosition, getMonthLabels } from './util'

import styles from './Calendar.module.scss'

export interface CalendarProps {
  startMonth: Date
  currIndex: number | null
  onClick: (closeDateIndex: number) => void
}

export const Calendar = ({ onClick, currIndex, startMonth }: CalendarProps) => (
  <div data-qa='RangeDatePicker-calendar' className={styles.container}>
    {getMonthLabels(startMonth, false).map((monthLabel, i) => (
      <Button
        minimal
        key={monthLabel}
        onClick={() => onClick(i)}
        style={{ left: getLeftPosition(i) }}
        data-qa={`RangeDatePicker-button-${i}`}
        className={classnames(styles.button, i === currIndex && styles.active)}
      >
        {monthLabel}
      </Button>
    ))}
  </div>
)
